import {
  canPanelAdminTier,
  canPanelManageInterventions,
  canPanelModeratePlayers,
  canPanelModoTier,
  canPanelScenariste,
  canPanelSystemCm,
  isPanelTeamMember,
} from './panelRoleAccess';

/**
 * Défauts « code » si aucune ligne BDD (ni individuel, ni rôle) pour la section.
 *
 * Modèle 18 rôles (migration _006) :
 *  - Founder (1)          : accès total (noyau inclus).
 *  - Directions (2, 3, 4) : tout le panel opérationnel + config de jeu (game_config), SAUF le noyau Founder (système, salon CM).
 *  - Admins (5–7)         : admin/premium/éco/rôles + modération + scénarios + salon admin + salon modo + scénariste.
 *  - Modos (8–11)         : modération + scénarios + salon modo + scénariste.
 *  - Team Member (14), Team Advisor (15) : dashboard + scénarios CTA + scénariste.
 *  - Community Manager (12), Support (13), Alpha Tester (16) : AUCUN accès panel.
 */
export function getCodeDefaultPanelAccess(sectionId: string, roleId: number): boolean {
  // Founder : accès total.
  if (roleId === 1) return true;

  // Directions (2, 3, 4) : tout le panel opérationnel, sauf le noyau réservé au Founder.
  if (roleId >= 2 && roleId <= 4 && sectionId !== 'system' && sectionId !== 'salon_cm') {
    return true;
  }

  switch (sectionId) {
    case 'stats':
      return isPanelTeamMember(roleId);
    case 'moderation':
    case 'salon_joueurs':
    case 'salon_security':
      return canPanelModeratePlayers(roleId);
    case 'interventions':
    case 'interventions_manage':
      return canPanelManageInterventions(roleId);
    case 'game_config':
    case 'recruitment':
      // Config de jeu / recrutement : Founder + directions (1-4). Les directions (2-4)
      // sont déjà autorisées par le retour anticipé ci-dessus ; ici seul le Founder
      // parmi les rôles restants passe (les rôles ≥ 5 sont refusés).
      return roleId === 1;
    case 'player_premium':
    case 'admin':
    case 'roles':
      return canPanelAdminTier(roleId);
    case 'system':
    case 'salon_cm':
      return canPanelSystemCm(roleId);
    case 'salon_admin':
      return canPanelAdminTier(roleId);
    case 'salon_modo':
      return canPanelModoTier(roleId);
    case 'salon_scenariste':
      return canPanelScenariste(roleId);
    case 'salon_ref':
      // Référent : résolu par canAccessSalonRefSection (assignation auth_referent + rôle 15).
      return false;
    default:
      return false;
  }
}
